import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import classNames from 'lib/util/classNames'
import styles from './BG.module.scss'
import { MASK } from './constants'

/**
 * The `BG`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function BG (props) {
  const { className, color, colorBorder, mask, opacity, opacityBorder } = props
  const maskStr = useMemo(() => MASK[mask] || mask, [mask])
  const classNameOutput = useMemo(
    () =>
      classNames([
        className,
        styles.bg,
        styles[`mask-${maskStr}`],
        styles[`color-${color}`],
        styles[`colorBorder-${colorBorder}`],
        styles[`opacity-${opacity}`],
        styles[`opacityBorder-${opacityBorder}`]
      ]),
    [className, maskStr, color, colorBorder, opacity, opacityBorder]
  )

  return (
    <div className={classNameOutput} aria-hidden="true">
      <div className={styles.bgGradient} />
      <div className={styles.bgBorder} />
    </div>
  )
}

/** @type {object} */
BG.propTypes = {
  className: PropTypes.string,
  mask: PropTypes.string,
  color: PropTypes.string,
  colorBorder: PropTypes.string,
  opacity: PropTypes.string,
  opacityBorder: PropTypes.string
}

/** @type {object} */
BG.defaultProps = {
  className: '',
  mask: 'short',
  color: 'b',
  colorBorder: 'a',
  opacity: 'd',
  opacityBorder: 'e'
}

// Memoize
export default memo(BG)
